import type { TStateKey } from '@model/aiReport';

type TStateName = 'Verifying' | 'Declined' | 'Confirmed' | 'History';

export const stateByKey: Record<TStateKey, TStateName> = {
  1: 'Verifying',
  2: 'Declined',
  3: 'Confirmed',
  4: 'History',
};
